import { Field, FieldProps, Formik } from "formik";
import * as React from "react";
import { Button, Col, Container, Form, Row } from "reactstrap";
import FormGroupWrapper from "../../Forms/FormGroupWrapper";
import { DirectDeal } from "../types";
import { useCreateOrUpdateDirectDeal } from "./CreateOrUpdateDirectDealMutation";
import { GET_DIRECT_DEAL } from "./DirectDealQuery";
import FormInputField from "../../Forms/FormInputField";
import IDDValidationSchema from "./IDDValidationSchema";
import { cleanFormData } from "../../../utils";
import { defaults } from "lodash";
import "./index.scss";
import config from "../../../config";

const urlComplaints = `${config.COMPLAINTS_URL}`;
const urlPrivacy = `${config.PRIVACY_URL}`;

const IDDForm = ({ directDeal }: { directDeal: DirectDeal }) => {
  const mutation = useCreateOrUpdateDirectDeal();

  return (
    <Container className="idd-form">
      <Row>
        <Col>
          <h3 className="idd-info">Important: Please Read</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3 className="idd-header">Initial Disclosure Document</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          This ‘Initial Disclosure Document’ is provided to help you decide
          whether our services are suitable for you, to let you know more about
          how we make our money, what to do if you have any concerns or
          complaints and how your information is used.
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <div className="idd-subheader">Who are we?</div>
          European Vehicle Contracts Limited trading as Eurodrive Motor
          Finance/Eurodrive Finance is a company registered within England and
          Wales, company number 06532275. Our Registered and Correspondence
          Address is{" "}
          <b>
            European House, 9 Apex Business Village, Newcastle upon Tyne, NE23
            7BF.
          </b>{" "}
          Our friendly team is on hand to support you within this journey and to
          answer any questions you may have.
          <br />
          As a Motor Finance Broker, our aim is to obtain the best financial
          acceptance to fit your circumstance. We work with a selected panel of
          finance partners in order to help you obtain an acceptance. Please
          note, we are only able to offer finance products from our panel of
          lenders. We’re happy to provide information on the finance products we
          offer at any time.
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <div className="idd-subheader">Contact us</div>
          Should you have any questions prior to making an application, or have
          any queries during or after your application has been made, you can
          contact us on the following information –{" "}
          <b>
            T: 0191 280 2855 E:{" "}
            <a href="mailto:info@eurodrivefinance.co.uk">
              info@eurodrivefinance.co.uk
            </a>
          </b>
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <div className="idd-subheader">Regulation</div>
          In order to carry out our activities, we are authorised and regulated
          by the Financial Conduct Authority (‘FCA’). Our <b>
            FRN is 649225
          </b>{" "}
          you can check this here -{" "}
          <a
            href="https://register.fca.org.uk/s/"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://register.fca.org.uk/s/
          </a>{" "}
          <b>We act as a credit broker, not a lender.</b>
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <div className="idd-subheader">Fees and Commissions</div>
          You will not be charged a fee for using our services. However, we must
          inform you that we receive a commission payment for introducing you to
          a lender. This commission will not impact any rate, amount or
          acceptance you are offered and is an agreed fixed payment or
          percentage of the amount financed. We have no control over the
          interest amount you are charged and therefore, the interest rate, the
          agreement length or the age of the car have no link or bearing on the
          fee that we are paid. This may vary by lender and we will advise you
          of the amount received and how it is calculated before you sign your
          agreement.
          <br />
          If you were introduced to us by a motor retailer, then we will also
          pay a commission to the retailer for the introduction. Details of the
          commission paid and how it is calculated will also be disclosed to you
          before you enter into your agreement.
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <div className="idd-subheader">Finance Options</div>
          In order to assist you with obtaining vehicle finance, your details
          will be passed over to finance providers with whom we work with.
          <br />
          We will arrange a soft search of your credit file. The soft search
          provides us with a credit score that determines the interest rate and
          lender that we will use for your finance application. The soft search
          will show on your credit file but other lenders will be unable to see
          it and so it will not affect their lending decisions Our finance
          providers, in order to assess your creditworthiness, will check your
          information with credit reference agencies, and potentially fraud
          prevention agencies. They will also use the information that you have
          provided us to assist them in assessing your current status and
          affordability. It is important that all the information you provide is
          accurate and up to date.
          <br />
          Please note that we cannot guarantee an acceptance and all potential
          finance is subject to terms and status.
          <br />
          Before entering into any agreement, you should ensure you have fully
          read and understood the agreement you are considering entering into.
          <br />
          We encourage you to take the time to read through any documentation
          provided, and please do ask any questions you may have. It is
          incredibly important you understand the type of agreement you are
          entering into along with your rights under the agreement such as (but
          not limited too) Distance Selling and the 14-day rule, Post Contract
          and your rights if there is an issue with the vehicle, Cancellation
          and what would happen should you not be able to keep up with the
          repayments. Our team is happy to answer any questions or go through
          anything in further detail, please contact us on the above.
          <br />
          We will never provide you with a recommendation or advise you on
          certain products, however our partners will provide you with all the
          information required within your Pre-Contract Information to assist
          you in making an informed decision.{" "}
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <div className="idd-subheader">Affordability</div>
          It is extremely important that you look into finance options that are
          suitable for your current (and potential future) financial situation.
          We or our dealers will go over all your details to ensure we have the
          correct information to pass onto our partners, who will then try to
          verify the information. However, please note that evidence of your
          income may be requested. If you are aware or suspect that your
          financial position will change in the future, you must inform us or
          the finance partner directly. Your credit rating could be adversely
          affected if you do not make payments when due.
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <div className="idd-subheader">Complaints</div>
          If you wish to make a complaint, please do contact us using the
          contact information above. For full information on how we handle
          complaints, please see our{" "}
          <a href={urlComplaints} rel="noopener noreferrer" target="_blank">
            Complaints Procedure
          </a>
          .
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <div className="idd-subheader">Your information</div>
          In order to process your application, you will need to provide us with
          some of your personal information directly or via one of our partners.
          We pride ourselves on handling your information in the most secure and
          professional way we can. Your data will not be processed without your
          explicit consent for us to do so, therefore if you do not wish for
          your application to be processed, we kindly ask that this is not
          submitted. As mentioned above, your information will be passed over to
          our finance partners in order to try to obtain you a finance
          acceptance. Whilst we have assessed the partners we work with; we have
          included their information within our privacy policy so you can fully
          research how they will use your information. For further detail on how
          your information is used by us and who it will be shared with, please
          view our{" "}
          <a href={urlPrivacy} rel="noopener noreferrer" target="_blank">
            Privacy Policy
          </a>
          . Our ICO number is Z2537167.
        </Col>
      </Row>
      <br />
      <Formik
        initialValues={
          defaults({}, directDeal, IDDValidationSchema.default()) as any
        }
        onSubmit={(values) => {
          const rawValues = cleanFormData(values);
          const { id } = rawValues;
          return mutation({
            variables: { input: rawValues },
            refetchQueries: [
              {
                query: GET_DIRECT_DEAL,
                variables: { directDealId: id },
              },
            ],
          });
        }}
        validateOnChange={false}
        validationSchema={IDDValidationSchema}
      >
        {(formikProps) => (
          <Form
            onSubmit={(e) => {
              formikProps.handleSubmit(e);
            }}
          >
            <>
              <Field name="iddSigned">
                {(fieldProps: FieldProps<any>) => (
                  <FormGroupWrapper className="mb-0" {...fieldProps}>
                    <div className="custom-control custom-checkbox font-weight-bold">
                      <input
                        id={fieldProps.field.name}
                        type="checkbox"
                        className="custom-control-input"
                        checked={!!fieldProps.field.value}
                        name={fieldProps.field.name}
                        onChange={() => {
                          fieldProps.form.setFieldValue(
                            fieldProps.field.name,
                            !fieldProps.field.value,
                            true,
                          );
                          fieldProps.form.setFieldTouched(
                            fieldProps.field.name,
                            true,
                            true,
                          );
                        }}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={fieldProps.field.name}
                      >
                        I have read the above document and agree to proceed
                      </label>
                    </div>
                  </FormGroupWrapper>
                )}
              </Field>
              <Row className="pt-3">
                <Field
                  colSize={4}
                  name="printName"
                  type="text"
                  placeholder="Print name"
                  title="Print name"
                  component={FormInputField}
                />
              </Row>
              <Button type="submit" color="primary">
                Confirm and proceed
              </Button>
            </>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default IDDForm;
